// shared/src/config/branding.ts

export type Product = 'PROLOGUE' | 'MAIN' | 'INSTANT' | 'MARKETING'

export interface Branding {
  productName: string
  productFullName: string
  tagline: string
  siteUrl: string
}

const BRANDING: Record<Product, Branding> = {
  PROLOGUE: {
    productName: 'PROLOGUE',
    productFullName: 'CRACKPOINT: PROLOGUE',
    tagline: 'Intercept. Decode. Breach.',
    siteUrl: 'https://prologue.crackpoint.app',
  },
  MAIN: {
    productName: 'CRACKPOINT',
    productFullName: 'CRACKPOINT',
    tagline: 'Crack the code. Break the system.',
    siteUrl: 'https://crackpoint.app',
  },
  INSTANT: {
    productName: 'QUICK CRACK',
    productFullName: 'CRACKPOINT: QUICK CRACK',
    tagline: 'Intercept. Decode. Breach.',
    siteUrl: 'https://instant.crackpoint.app',
  },
  MARKETING: {
    productName: 'CRACKPOINT',
    productFullName: 'CRACKPOINT',
    tagline: 'Crack the code. Break the system.',
    siteUrl: 'https://crackpoint.co.uk',
  },
}

export function getBranding(product?: Product): Branding {
  const p = product ?? (detectProduct())
  return BRANDING[p]
}

function detectProduct(): Product {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_PRODUCT) {
    return import.meta.env.VITE_PRODUCT as Product
  }
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_ADAPTER_MODE === 'client') {
    return 'INSTANT'
  }
  return 'PROLOGUE'
}
